export const UserCompanyDetails = {
    GET_USERSWITHCOMPANIES: "GET_USERSWITHCOMPANIES",
    POST_USERSWITHCOMPANIES: "POST_USERSWITHCOMPANIES",
    UPDATE_USERSWITHCOMPANIES: "UPDATE_USERSWITHCOMPANIES",
    GET_SUBCOMPANIESBYUSERID: "GET_SUBCOMPANIESBYUSERID",
    DELETE_USERSWITHCOMPANIES: "DELETE_USERSWITHCOMPANIES",
   
}
